import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { useMapStore } from '@/stores/mapStore';
import type { PointGeometry } from '@/types/map';

export default function SearchArea() {
  const map = useMap();
  const searchAreas = useMapStore((s) => s.searchAreas);
  const layerRef = useRef<L.LayerGroup>(L.layerGroup());

  useEffect(() => {
    layerRef.current.addTo(map);
    return () => {
      layerRef.current.remove();
    };
  }, [map]);

  useEffect(() => {
    layerRef.current.clearLayers();

    searchAreas.forEach((feature) => {
      const geom = feature.geometry as PointGeometry;
      const [lon, lat] = geom.coordinates;
      const props = feature.properties;
      const radiusKm = props.radius_km || 10;

      L.circle([lat, lon], {
        radius: radiusKm * 1000,
        color: props.stroke || '#3b82f6',
        weight: 2,
        opacity: 0.6,
        fillColor: props.fill || '#3b82f6',
        fillOpacity: props.fill_opacity || 0.1,
      }).addTo(layerRef.current);
    });
  }, [searchAreas]);

  return null;
}
